import { observable } from "mobx";
import http from 'libs/http';
import ClassStore from "../../student/class/store";

class Store {
  @observable records = [];
  @observable types = [];
  @observable record = {};
  @observable isFetching = false;
  @observable formVisible = false;
  @observable class_info = [];
  @observable st_class_name = [];

  @observable f_class;

  fetchRecords = () => {
    this.isFetching = true;
    http.get('/api/homework/record/')
      .then((res) => {
        this.records = res;
      })
      .finally(() => this.isFetching = false)
  };

  showForm = (info = {}) => {
    this.formVisible = true;
    this.record = info;
    this.st_class_name = ClassStore.records;
  }
}

export default new Store()
